import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

export async function getDados(cod_ibge, co_ubs, mes, ano, tipo) {
  try {
    let url = `/app/v2/bpa-c/${cod_ibge}/${co_ubs}/${mes}-${ano}`

    if (tipo != null) {
      url += `/${tipo.value}`
    }

    const { data } = await api.get(url)
    return data
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(cadastros, unidade_de_saude, mes, ano) {
  const titlePdf = 'BPA C'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, '')
  const descriptionPdf = 'Procedimentos Ambulatoriais Consolidados'
  const headersPdf = [
    'FOLHA',
    'SEQUÊNCIA',
    'PROCEDIMENTO',
    'CBO',
    'IDADE',
    'QUANTIDADE',
  ]

  const dataPdf = cadastros.map((item, index) => {
    let seq_global = Number(item.seq_global) || 0
    let sequencia = ((seq_global - 1) % 20) + 1
    let folha = Math.floor((seq_global - 1) / 20) + 1
    return {
      folha: folha,
      sequencia: sequencia,
      procedimento: item.procedimento,
      cbo: item.cbo,
      idade: item.idade,
      quantidade: item.quantidade,
    }
  })

  const table = utils.methods.createTablePdf(dataPdf)
  const doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      // Cabeçalho
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      // Informações adicionais
      const bodyInfo = [
        { label: 'Unidade de saúde', value: unidade_de_saude },
        { label: 'MÊS/ANO', value: `${mes}/${ano}` },
      ]
      verticalPosition = utils.methods.bodyPdf(doc, bodyInfo, verticalPosition)

      // Tabela
      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
      })

      // Rodapé e salvar
      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
